import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Cuando la URL incluye un hash (ej. #item-3-fechaSiguienteCiclo), busca el
 * elemento en el DOM, hace scroll suave hasta el y aplica la clase
 * .anchor-highlight por 2 segundos para que el usuario identifique
 * visualmente el campo objetivo.
 *
 * Idempotente: si el elemento no existe en el DOM (anchor obsoleto),
 * no hace nada.
 */
export function useAnchorScroll() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.slice(1);
    const el = document.getElementById(id);
    if (!el) return;

    requestAnimationFrame(() => {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("anchor-highlight");
      setTimeout(() => el.classList.remove("anchor-highlight"), 2000);
    });
  }, [location.hash]);
}
